module.exports = __webpack_public_path__ + "img/Motec.ca4467b.jpg";